export const DEV_RESET_USER = 'DEV_RESET_USER'
export const DEV_RESET_CORPORATE_CUSTOMER = 'DEV_RESET_CORPORATE_CUSTOMER'
export const DEV_VERIFICATION_TEST = 'DEV_VERIFICATION_TEST'
export const DEV_RESET_PLAID_LOGIN = 'DEV_RESET_PLAID_LOGIN'
export const DEV_RESET_HRIS_INFORMATION = 'DEV_RESET_HRIS_INFORMATION'
export const GET_USER = 'GET_USER'
export const SET_USER = 'SET_USER'
export const SET_LAST_LOGIN = 'SET_LAST_LOGIN'
export const GET_MY_TRIPS = 'GET_MY_TRIPS'
export const GET_PAST_TRIPS = 'GET_PAST_TRIPS'
export const GET_ALL_TRIPS = 'GET_ALL_TRIPS'
export const GET_TRIP = 'GET_TRIP'
export const GET_SAVINGS_TOTALS = 'GET_SAVINGS_TOTALS'
export const GET_SAVINGS_GOAL = 'GET_SAVINGS_GOAL'
export const SET_SAVINGS_GOAL = 'SET_SAVINGS_GOAL'
export const GET_SAVINGS_HISTORY = 'GET_SAVINGS_HISTORY'
export const GET_SAVINGS_GRAPH = 'GET_SAVINGS_GRAPH'
export const GET_ACCOUNT_DETAILS = 'GET_ACCOUNT_DETAILS'
export const SET_ACCOUNT_DETAILS = 'SET_ACCOUNT_DETAILS'
export const CREATE_PLAID_LINK_TOKEN = 'CREATE_PLAID_LINK_TOKEN'
export const RELINK_PLAID = 'RELINK_PLAID'
export const GET_PLAID_ACCESS_TOKEN = 'GET_PLAID_ACCESS_TOKEN'
export const CLEAR_PLAID_STATUS = 'CLEAR_PLAID_STATUS'
export const BOOST_ACCOUNT = 'BOOST_ACCOUNT'
export const MAKE_TRANSACTION = 'MAKE_TRANSACTION'
export const MAKE_CORPORATE_TRANSACTION = 'MAKE_CORPORATE_TRANSACTION'
export const GET_TRAVEL_COMPANIONS = 'GET_TRAVEL_COMPANIONS'
export const GET_TRAVEL_PASSPORTS = 'GET_TRAVEL_PASSPORTS'
export const CREATE_TRAVEL_PASSPORT = 'CREATE_TRAVEL_PASSPORT'
export const SET_TRAVEL_PASSPORT = 'SET_TRAVEL_PASSPORT'
export const DELETE_TRAVEL_PASSPORT = 'DELETE_TRAVEL_PASSPORT'
export const GET_TRAVEL_LOYALTIES = 'GET_TRAVEL_LOYALTIES'
export const SET_TRAVEL_LOYALTY = 'SET_TRAVEL_LOYALTY'
export const UPDATE_TRAVEL_LOYALTY = 'UPDATE_TRAVEL_LOYALTY'
export const DELETE_TRAVEL_LOYALTY = 'DELETE_TRAVEL_LOYALTY'
export const GET_TRAVEL_LOYALTY_BY_TYPE = 'GET_TRAVEL_LOYALTY_BY_TYPE'
export const GET_SETUP_STEPS = 'GET_SETUP_STEPS'
export const GET_SAVINGS_ACCOUNTS = 'GET_SAVINGS_ACCOUNTS'
export const GET_SAVINGS_PAYMENT_METHODS = 'GET_SAVINGS_PAYMENT_METHODS'
export const GET_NOTIFICATION_PREFERENCES = 'GET_NOTIFICATION_PREFERENCES'
export const GET_INTENTIONS = 'GET_INTENTIONS'
export const GET_ONBOARDING = 'GET_ONBOARDING'
export const GET_ONBOARDING_DOCUMENTS = 'GET_ONBOARDING_DOCUMENTS'
export const GET_ONBOARDING_DOCUMENT_STATUS = 'GET_ONBOARDING_DOCUMENT_STATUS'
export const GET_ONBOARDING_AGREEMENTS = 'GET_ONBOARDING_AGREEMENTS'
export const SET_ONBOARDING_AGREEMENTS = 'SET_ONBOARDING_AGREEMENTS'
export const SET_ONBOARDING_GENERAL_INFO = 'SET_ONBOARDING_GENERAL_INFO'
export const SET_ONBOARDING_INCOME_INFO = 'SET_ONBOARDING_INCOME_INFO'
export const SET_ONBOARDING_PERSONAL_IDENTIFICATION = 'SET_ONBOARDING_PERSONAL_IDENTIFICATION'
export const GET_ONBOARDING_STATUS = 'GET_ONBOARDING_STATUS'
export const GET_KBA_QUESTIONS = 'GET_KBA_QUESTIONS'
export const SUBMIT_KBA_ANSWERS = 'SUBMIT_KBA_ANSWERS'
export const INIT_KBA = 'INIT_KBA'
export const GET_CORPORATE_ONBOARDING = 'GET_CORPORATE_ONBOARDING'
export const SET_CORPORATE_ONBOARDING = 'SET_CORPORATE_ONBOARDING'
export const GET_CORPORATE_ONBOARDING_DOCUMENTS = 'GET_CORPORATE_ONBOARDING_DOCUMENTS'
export const SET_CORPORATE_ONBOARDING_DOCUMENTS = 'SET_CORPORATE_ONBOARDING_DOCUMENTS'
export const GET_CORPORATE_ONBOARDING_AGREEMENTS = 'GET_CORPORATE_ONBOARDING_AGREEMENTS'
export const SET_CORPORATE_ONBOARDING_AGREEMENTS = 'SET_CORPORATE_ONBOARDING_AGREEMENTS'
export const CREATE_BENEFICIAL_OWNER = 'CREATE_BENEFICIAL_OWNER'
export const GET_BENEFICIAL_OWNERS = 'GET_BENEFICIAL_OWNERS'
export const DELETE_BENEFICIAL_OWNER = 'DELETE_BENEFICIAL_OWNER'
export const CERTIFY_BENEFICIAL_OWNERS = 'CERTIFY_BENEFICIAL_OWNERS'
export const GET_CONTRIBUTION_SETTINGS = 'GET_CONTRIBUTION_SETTINGS'
export const CREATE_CONTRIBUTION_SETTINGS = 'CREATE_CONTRIBUTION_SETTINGS'
export const UPDATE_CONTRIBUTION_SETTINGS = 'UPDATE_CONTRIBUTION_SETTINGS'
export const GET_EXTERNAL_ACCOUNTS = 'GET_EXTERNAL_ACCOUNTS'
export const DELETE_EXTERNAL_ACCOUNT = 'DELETE_EXTERNAL_ACCOUNT'
export const GET_CORPORATE_EXTERNAL_ACCOUNTS = 'GET_CORPORATE_EXTERNAL_ACCOUNTS'
export const DELETE_CORPORATE_EXTERNAL_ACCOUNT = 'DELETE_CORPORATE_EXTERNAL_ACCOUNT'
export const GET_CORPORATE_TRANSACTION_HISTORY = 'GET_CORPORATE_TRANSACTION_HISTORY'
export const GET_CORPORATE_WALLET_HISTORY = 'GET_CORPORATE_WALLET_HISTORY'
export const GET_PTO_EXPLAINER = 'GET_PTO_EXPLAINER'
export const GET_EMPLOYEES = 'GET_EMPLOYEES'
export const GET_MANAGERS = 'GET_MANAGERS'
export const GET_TEAM = 'GET_TEAM'
export const GET_MANAGER_TEAM = 'GET_MANAGER_TEAM'
export const CREATE_EMPLOYEE = 'CREATE_EMPLOYEE'
export const UPDATE_EMPLOYEE = 'UPDATE_EMPLOYEE'
export const UPLOAD_EMPLOYEES = 'UPLOAD_EMPLOYEES'
export const DELETE_EMPLOYEE = 'DELETE_EMPLOYEE'
export const SET_EMPLOYEE_ROLE = 'SET_EMPLOYEE_ROLE'
export const GET_BUSINESS_CLASSIFICATIONS = 'GET_BUSINESS_CLASSIFICATIONS'
export const GET_SURVEY = 'GET_SURVEY'
export const SET_SURVEY = 'SET_SURVEY'
export const SET_TRAVEL_INTENTION = 'SET_TRAVEL_INTENTION'
export const GET_COMPANY = 'GET_COMPANY'
export const SET_COMPANY = 'SET_COMPANY'
export const GET_COUNTRIES = 'GET_COUNTRIES'
export const GET_AIRPORTS = 'GET_AIRPORTS'
export const GET_AIRLINES = 'GET_AIRLINES'
export const GET_STAYS = 'GET_STAYS'
export const GET_LOCATIONS = 'GET_LOCATIONS'
export const GET_OCEAN_CRUISES = 'GET_OCEAN_CRUISES'
export const GET_OCEAN_DESTINATIONS = 'GET_OCEAN_DESTINATIONS'
export const GET_OCEAN_CRUISE_TOURS = 'GET_OCEAN_CRUISE_TOURS'
export const GET_RIVER_CRUISES = 'GET_RIVER_CRUISES'
export const GET_RIVER_DESTINATIONS = 'GET_RIVER_DESTINATIONS'
export const GET_RIVER_CITIES = 'GET_RIVER_CITIES'
export const GET_RIVER_COUNTRIES = 'GET_RIVER_COUNTRIES'
export const GET_RIVER_LINES = 'GET_RIVER_LINES'
export const GET_RIVER_SHIPS = 'GET_RIVER_SHIPS'
export const GET_RIVER_WATERWAYS = 'GET_RIVER_DESTINATIONS'
export const GET_TOUR_VENDORS = 'GET_TOUR_VENDORS'
export const GET_CAR_VENDORS = 'GET_CAR_VENDORS'
export const GET_EXPERIENCE_LOCATIONS = 'GET_EXPERIENCE_LOCATIONS'
export const GET_EXPERIENCES = 'GET_EXPERIENCES'
export const SEARCH_VIATOR = 'SEARCH_VIATOR'
export const GET_VIATOR_EXPERIENCES = 'GET_VIATOR_EXPERIENCES'
export const GET_VIATOR_AVAILABILITY = 'GET_VIATOR_AVAILABILITY'
export const GET_EXPERIENCE_TAGS = 'GET_EXPERIENCE_TAGS'
export const UPLOAD_ID_DOCUMENT = 'UPLOAD_ID_DOCUMENT'
export const GET_CORPORATE_ONBOARDING_STATUS = 'GET_CORPORATE_ONBOARDING_STATUS'
export const GET_CORPORATE_DOCUMENT_STATUS = 'GET_CORPORATE_DOCUMENT_STATUS'
export const GET_AUTHORIZATION_TEXT = 'GET_AUTHORIZATION_TEXT'
export const COMPLETE_ACCOUNT = 'COMPLETE_ACCOUNT'
export const CLEAR_ACCOUNT_ERROR = 'CLEAR_ACCOUNT_ERROR'
export const CANCEL_TRANSACTION = 'CANCEL_TRANSACTION'
export const GET_BENEFICIAL_OWNER_DETAILS = 'GET_BENEFICIAL_OWNER_DETAILS'
export const CANCEL_CORPORATE_TRANSACTION = 'CANCEL_CORPORATE_TRANSACTION'
export const CANCEL_MANAGER_TRANSACTION = 'CANCEL_MANAGER_TRANSACTION'
export const SET_BENEFICIAL_OWNER_DOCUMENTS = 'SET_BENEFICIAL_OWNER_DOCUMENTS'
export const GET_BENEFICIAL_OWNER_STATUS = 'GET_BENEFICIAL_OWNER_STATUS'
export const ENCRYPT_TOKEN = 'ENCRYPT_TOKEN'
export const GET_INTERNAL_ONBOARDING_AGREEMENTS = 'GET_INTERNAL_ONBOARDING_AGREEMENTS'
export const GET_INTERNAL_CORP_ONBOARDING_AGREEMENTS = 'GET_INTERNAL_CORP_ONBOARDING_AGREEMENTS'
export const GET_COMPANY_MATCH = 'GET_COMPANY_MATCH'
export const CREATE_BOOKING_REQUEST = 'CREATE_BOOKING_REQUEST'
export const GET_EXPERIENCE_DETAILS = 'GET_EXPERIENCE_DETAILS'
export const GET_CONTENT_DETAILS = 'GET_CONTENT_DETAILS'
export const GET_CONTENT = 'GET_CONTENT'
export const GET_DESTINATION = 'GET_DESTINATION'
export const GET_CATEGORIES = 'GET_CATEGORIES'
export const GET_VENDORS = 'GET_VENDORS'
export const GET_FEATURED_VENDORS = 'GET_FEATURED_VENDORS'
export const GET_VENDOR = 'GET_VENDOR'
export const GET_FAQ_CATEGORIES = 'GET_FAQ_CATEGORIES'
export const GET_FAQ = 'GET_FAQ'
export const BULK_EMPLOYEE_DELETE = 'BULK_EMPLOYEE_DELETE'
export const BULK_EMPLOYEE_EDIT = 'BULK_EMPLOYEE_EDIT'
export const BULK_EMPLOYEE_INVITE = 'BULK_EMPLOYEE_INVITE'
export const SEARCH_EMPLOYEES = 'SEARCH_EMPLOYEES'
export const SEARCH_MANAGERS = 'SEARCH_MANAGERS'
export const GET_EMPLOYEE_UPLOAD_RESULTS = 'GET_EMPLOYEE_UPLOAD_RESULTS'
export const INVITE_USER = 'INVITE_USER'
export const MAKE_BULK_CORPORATE_TRANSACTION = 'MAKE_BULK_CORPORATE_TRANSACTION'
export const GET_BULK_EMPLOYEE_REWARD_ATTEMPTS = 'GET_BULK_EMPLOYEE_REWARD_ATTEMPTS'
export const GET_EMPLOYEE_UPLOAD_LOG = 'GET_EMPLOYEE_UPLOAD_LOG'
export const EMAIL_CORPORATE_TRANSACTION_HISTORY = 'EMAIL_CORPORATE_TRANSACTION_HISTORY'
export const CREATE_ITINERARY = 'CREATE_ITINERARY'
export const UPDATE_ITINERARY = 'UPDATE_ITINERARY'
export const REMOVE_ITINERARY = 'REMOVE_ITINERARY'
export const MOVE_ITINERARY = 'MOVE_ITINERARY'
export const UPDATE_TRIP = 'UPDATE_TRIP'
export const DELETE_TRIP = 'DELETE_TRIP'
export const CREATE_TRIP = 'CREATE_TRIP'
export const MERGE_TRIPS = 'MERGE_TRIPS'
export const GET_DESTINATION_CATEGORIES = 'GET_DESTINATION_CATEGORIES'
export const GET_TRAVEL_CATEGORIES = 'GET_TRAVEL_CATEGORIES'
export const REQUEST_ITINERARY_CANCELLATION = 'REQUEST_ITINERARY_CANCELLATION'
export const GET_ALL_BUDGETS = 'GET_ALL_BUDGETS'
export const GET_MY_BUDGETS = 'GET_MY_BUDGETS'
export const GET_MANAGER_DETAILS = 'GET_MANAGER_DETAILS'
export const UPDATE_BUDGET = 'UPDATE_BUDGET'
export const GET_BUDGET = 'GET_BUDGET'
export const CREATE_BUDGET = 'CREATE_BUDGET'
export const CREATE_BULK_BUDGET = 'CREATE_BULK_BUDGET'
export const DELETE_BUDGET = 'DELETE_BUDGET'
export const REWARD_MANAGER_TO_EMPLOYEE = 'REWARD_MANAGER_TO_EMPLOYEE'
export const BULK_REWARD_MANAGER_TO_EMPLOYEE = 'BULK_REWARD_MANAGER_TO_EMPLOYEE'
export const GET_BUDGET_HISTORY = 'GET_BUDGET_HISTORY'
export const REQUEST_ADDITIONAL_BUDGET = 'REQUEST_ADDITIONAL_BUDGET'
export const REQUEST_BUDGET = 'REQUEST_BUDGET'
export const CREATE_MERGE_LINK_TOKEN = 'CREATE_MERGE_LINK_TOKEN'
export const GET_MERGE_ACCESS_TOKEN = 'GET_MERGE_ACCESS_TOKEN'
export const GET_REWARD_LOG = 'GET_REWARD_LOG'
export const GET_COMPANY_IMAGES = 'GET_COMPANY_IMAGES'
export const ADD_COMPANY_IMAGE = 'ADD_COMPANY_IMAGE'
export const BULK_ADD_COMPANY_IMAGES = 'BULK_ADD_COMPANY_IMAGES'
export const FLAG_COMPANY_IMAGE = 'FLAG_COMPANY_IMAGE'
export const REMOVE_COMPANY_IMAGE = 'REMOVE_COMPANY_IMAGE'
export const BULK_REMOVE_COMPANY_IMAGES = 'BULK_REMOVE_COMPANY_IMAGES'
export const GET_CUSTOMER_LOCATIONS = 'GET_CUSTOMER_LOCATIONS'
export const GET_VOTED_LOCATIONS = 'GET_VOTED_LOCATIONS'
export const VOTE_LOCATIONS = 'VOTE_LOCATIONS'
export const GET_COMPANY_SETTINGS = 'GET_COMPANY_SETTINGS'
export const UPDATE_COMPANY_SETTINGS = 'UPDATE_COMPANY_SETTINGS'
export const GET_COMPANY_PTO_EXPLAINER = 'GET_COMPANY_PTO_EXPLAINER'
export const UPDATE_COMPANY_PTO_EXPLAINER = 'UPDATE_COMPANY_PTO_EXPLAINER'
export const GET_USER_SETTINGS = 'GET_USER_SETTINGS'
export const UPDATE_USER_SETTINGS = 'UPDATE_USER_SETTINGS'
export const GET_TRAVEL_CURIOUS_PROMOTED_CITIES = 'GET_TRAVEL_CURIOUS_PROMOTED_CITIES'
export const GET_TRAVEL_CURIOUS_CITIES = 'GET_TRAVEL_CURIOUS_CITIES'
export const GET_TRAVEL_CURIOUS_TOURS = 'GET_TRAVEL_CURIOUS_TOURS'
export const BOOK_TRAVEL_CURIOUS = 'BOOK_TRAVEL_CURIOUS'
export const REQUEST_VIATOR_VC = 'REQUEST_VIATOR_VC'
export const SET_EMAIL_COMMUNICATION_PREFERENCES = 'SET_EMAIL_COMMUNICATION_PREFERENCES'
export const BULK_ADD_TRIP_IMAGES = 'BULK_ADD_TRIP_IMAGES'
export const BULK_REMOVE_TRIP_IMAGES = 'BULK_REMOVE_TRIP_IMAGES'
export const GET_COMPANY_ACTIVITY = 'GET_COMPANY_ACTIVITY'
export const GET_FIRST_SYNC_STATUS = 'GET_FIRST_SYNC_STATUS'
export const GET_HRIS_ACCOUNTS = 'GET_HRIS_ACCOUNTS'
export const UPDATE_HRIS_ACCOUNT = 'UPDATE_HRIS_ACCOUNT'
export const REMOVE_HRIS_ACCOUNT = 'REMOVE_HRIS_ACCOUNT'
export const GET_HRIS_ELIGIBILITY = 'GET_HRIS_ELIGIBILITY'
export const UPDATE_HRIS_ELIGIBILITY = 'UPDATE_HRIS_ELIGIBILITY'
export const CONFIRM_ELIGIBILITY_RULES = 'CONFIRM_ELIGIBILITY_RULES'
export const GET_HRIS_STATUS_COUNTS = 'GET_HRIS_STATUS_COUNTS'
export const PROCESS_ELIGIBLE_EMPLOYEES = 'PROCESS_ELIGIBLE_EMPLOYEES'
export const OVERRIDE_EMPLOYEE_ELIGIBILITY = 'OVERRIDE_EMPLOYEE_ELIGIBILITY'
export const OVERRIDE_EMPLOYEE_INELIGIBILITY = 'OVERRIDE_EMPLOYEE_INELIGIBILITY'
export const CONFIRM_INELIGIBILITY = 'CONFIRM_INELIGIBILITY'
export const GET_UNMERGED_EMPLOYEES = 'GET_UNMERGED_EMPLOYEES'
export const SEARCH_HRIS_EMPLOYEES = 'SEARCH_HRIS_EMPLOYEES'
export const GET_PAGINATED_HRIS_RECORDS = 'GET_PAGINATED_HRIS_RECORDS'
export const MERGE_HRIS_EMPLOYEE = 'MERGE_HRIS_EMPLOYEE'
export const DEACTIVATE_HRIS_EMPLOYEE = 'DEACTIVATE_HRIS_EMPLOYEE'
export const GET_HRIS_STATUS = 'GET_HRIS_STATUS'
export const SEND_HRIS_EMPLOYEE_INVITES = 'SEND_HRIS_EMPLOYEE_INVITES'
export const GET_COLLECTIONS = 'GET_COLLECTIONS'
export const GET_ALL_COLLECTIONS = 'GET_ALL_COLLECTIONS'
export const GET_COLLECTION = 'GET_COLLECTION'
export const CHANGE_COLLECTION_NAME = 'CHANGE_COLLECTION_NAME'
export const CREATE_COLLECTION = 'CREATE_COLLECTION'
export const DELETE_COLLECTION = 'DELETE_COLLECTION'
export const MERGE_COLLECTIONS = 'MERGE_COLLECTIONS'
export const CONNECT_COLLECTION_TO_TRIP = 'CONNECT_COLLECTION_TO_TRIP'
export const DISCONNECT_COLLECTION_FROM_TRIP = 'DISCONNECT_COLLECTION_FROM_TRIP'
export const GET_FAVORITES = 'GET_FAVORITES'
export const ADD_FAVORITE = 'ADD_FAVORITE'
export const REMOVE_FAVORITE = 'REMOVE_FAVORITE'
export const ADD_CONTENT_TO_COLLECTION = 'ADD_CONTENT_TO_COLLECTION'
export const REMOVE_CONTENT_FROM_COLLECTION = 'REMOVE_CONTENT_FROM_COLLECTION'
export const GET_RECENT_CONTENT = 'GET_RECENT_CONTENT'
export const GET_BOOKING_STATS = 'GET_BOOKING_STATS'
export const GET_BUDGET_STATS = 'GET_BUDGET_STATS'
export const GET_EMPLOYEE_STATS = 'GET_EMPLOYEE_STATS'
export const GET_FUNDING_STATS = 'GET_FUNDING_STATS'
export const GET_EVOLVE_MIGRATION_SETTING = 'GET_EVOLVE_MIGRATION_SETTING'
export const GET_HOTELS = 'GET_HOTELS'
export const SEARCH_NEARBY_STAYS = 'SEARCH_NEARBY_STAYS'
export const GET_HOTEL_AMENITIES = 'GET_HOTEL_AMENITIES'
export const GET_HOTEL = 'GET_HOTEL'
export const GET_HOTEL_AVAILABILITY = 'GET_HOTEL_AVAILABILITY'
export const BOOK_HOTEL_PLANNER = 'BOOK_HOTEL_PLANNER'
export const GET_HOTEL_PLANNER_RESERVATION_STATUS = 'GET_HOTEL_PLANNER_RESERVATION_STATUS'
export const REQUEST_HOTEL_PLANNER_CANCELLATION = 'REQUEST_HOTEL_PLANNER_CANCELLATION'
export const GET_RANDOM_DESTINATIONS = 'GET_RANDOM_DESTINATIONS'
export const GET_SEARCH_HISTORY = 'GET_SEARCH_HISTORY'
export const ADD_TO_SEARCH_HISTORY = 'ADD_TO_SEARCH_HISTORY'
export const GENERAL_ERROR = 'GENERAL_ERROR'
export const GET_MATCH_HISTORY = 'GET_MATCH_HISTORY'
export const GET_PAYROLL_ACCESS_TOKEN = 'GET_PAYROLL_ACCESS_TOKEN'
export const GET_PAYROLL_ACCOUNTS = 'GET_PAYROLL_ACCOUNTS'
export const REQUEST_ADMIN_PAYROLL_DISCONNECT = 'REQUEST_ADMIN_PAYROLL_DISCONNECT'
export const SET_PAYROLL_DISCONNECT_REQUEST = 'SET_PAYROLL_DISCONNECT_REQUEST'
export const REMOVE_PAYROLL = 'REMOVE_PAYROLL'
export const INVITE_INACTIVE_USERS = 'INVITE_INACTIVE_USERS'
export const REQUEST_PARTNER_VC = 'REQUEST_PARTNER_VC'
export const REQUEST_FLIGHT_VC = 'REQUEST_FLIGHT_VC'
export const GET_MY_REWARDS = 'GET_MY_REWARDS'
export const GET_INSURANCE_PRODUCTS = 'GET_INSURANCE_PRODUCTS'
export const GET_INSURANCE_PRODUCT_STATES = 'GET_INSURANCE_PRODUCT_STATES'
export const GET_INSURANCE_PRODUCTS_HOST_COUNTRIES = 'GET_INSURANCE_PRODUCTS_HOST_COUNTRIES'
export const GET_INSURANCE_PRODUCTS_DESTINATION_COUNTRIES = 'GET_INSURANCE_PRODUCTS_DESTINATION_COUNTRIES'
export const GET_INSURANCE_PRODUCTS_BY_STATE = 'GET_INSURANCE_PRODUCTS_BY_STATE'
export const GET_INSURANCE_UPFRONT_QUOTE = 'GET_INSURANCE_UPFRONT_QUOTE'
export const GET_INSURANCE_FINAL_QUOTE = 'GET_INSURANCE_FINAL_QUOTE'
export const BOOK_INSURANCE = 'BOOK_INSURANCE'
export const GET_INSURANCE_PAYMENT = 'GET_INSURANCE_PAYMENT'
export const GET_INSURANCE_POLICY_FILES = 'GET_INSURANCE_POLICY_FILES'
export const GET_INSURANCE_POLICY_TRIP = 'GET_INSURANCE_POLICY_TRIP'
export const GET_INSURANCE_POLICY_DETAILS = 'GET_INSURANCE_POLICY_DETAILS'
export const ADD_POLICY_TO_TRIP = 'ADD_POLICY_TO_TRIP'
export const REMOVE_POLICY_FROM_TRIP = 'REMOVE_POLICY_FROM_TRIP'
export const CREATE_KYB_BUSINESS = 'CREATE_KYB_BUSINESS'
export const GET_KYB_INQUIRY_ID = 'GET_KYB_INQUIRY_ID'
export const SET_KYB_UNDER_REVIEW = 'SET_KYB_UNDER_REVIEW'
export const GET_MAX_WITHDRAWAL = 'GET_MAX_WITHDRAWAL'
export const REQUEST_FUND_WITHDRAWAL = 'REQUEST_FUND_WITHDRAWAL'
export const GET_USER_STATEMENT_PDF = 'GET_USER_STATEMENT_PDF'
export const GET_CORPORATE_STATEMENT_PDF = 'GET_CORPORATE_STATEMENT_PDF'
export const GET_CORPORATE_STATEMENT = 'GET_CORPORATE_STATEMENT'
export const GET_BANK_AUTHORIZATION = 'GET_BANK_AUTHORIZATION'
export const CONNECT_POLICY_TO_TRIP = 'CONNECT_POLICY_TO_TRIP'
export const GET_POLICIES = 'GET_POLICIES'
export const SET_MIGRATION_STATUS = 'SET_MIGRATION_STATUS'
export const CHECK_PENDING_TRANSACTIONS = 'CHECK_PENDING_TRANSACTIONS'
export const GET_AFFILIATES = 'GET_AFFILIATES'
export const GET_OFFERS = 'GET_OFFERS'
export const REQUEST_AFFILIATE_VCC = 'REQUEST_AFFILIATE_VCC'
export const REQUEST_GENERAL_VC = 'REQUEST_GENERAL_VC'
export const SEND_AMOUNT_DISPUTE_TICKET = 'SEND_AMOUNT_DISPUTE_TICKET'
export const GET_GENERAL_SETTING = 'GET_GENERAL_SETTING'
export const GET_DESTINATION_IMAGE = 'GET_DESTINATION_IMAGE'
export const GET_VIRTUAL_CARDS = 'GET_VIRTUAL_CARDS'
export const GET_VIRTUAL_CARD = 'GET_VIRTUAL_CARD'
export const GET_VIRTUAL_CARD_LINK = 'GET_VIRTUAL_CARD_LINK'
export const CANCEL_VIRTUAL_CARD = 'CANCEL_VIRTUAL_CARD'
export const REPORT_VIRTUAL_CARD_ISSUE = 'REPORT_VIRTUAL_CARD_ISSUE'
export const GET_AI_MODELS = 'GET_AI_MODELS'
export const GET_AI_MODEL = 'GET_AI_MODEL'
export const SEND_AI_CHAT = 'SEND_AI_CHAT'
export const SEND_AI_COMPLETION = 'SEND_AI_COMPLETION'
export const GET_AI_FINE_TUNE = 'GET_AI_FINE_TUNE'
export const SEND_CUSTOMER_SERVICE_REQUEST = 'SEND_CUSTOMER_SERVICE_REQUEST'
export const REQUEST_REIMBURSEMENT = 'REQUEST_REIMBURSEMENT'
export const GET_MONTHLY_DEAL = 'GET_MONTHLY_DEAL'
export const GET_EXPERIENCES_AUTOCOMPLETE = 'GET_EXPERIENCES_AUTOCOMPLETE'
export const SEARCH_HOLIBOB = 'SEARCH_HOLIBOB'
export const SEARCH_NEARBY_EXPERIENCES = 'SEARCH_NEARBY_EXPERIENCES'
export const GET_HOLIBOB_EXPERIENCE_TAGS = 'GET_HOLIBOB_EXPERIENCE_TAGS'
export const GET_HOLIBOB_CATEGORIES = 'GET_HOLIBOB_CATEGORIES'
export const GET_HOLIBOB_PLACES = 'GET_HOLIBOB_PLACES'
export const GET_HOLIBOB_PRODUCT_DETAILS = 'GET_HOLIBOB_PRODUCT_DETAILS'
export const GET_HOLIBOB_PRODUCT_AVAILABILITY_LIST = 'GET_HOLIBOB_PRODUCT_AVAILABILITY_LIST'
export const GET_HOLIBOB_PRODUCT_AVAILABILITY = 'GET_HOLIBOB_PRODUCT_AVAILABILITY'
export const GET_HOLIBOB_PRODUCT_OPTIONS = 'GET_HOLIBOB_PRODUCT_OPTIONS'
export const GET_HOLIBOB_PRODUCT_PRICING = 'GET_HOLIBOB_PRODUCT_PRICING'
export const BOOK_HOLIBOB = 'BOOK_HOLIBOB'
export const ADD_HOLIBOB_AVAILABILITY_TO_BOOKING = 'ADD_HOLIBOB_AVAILABILITY_TO_BOOKING'
export const GET_HOLIBOB_BOOKING = 'GET_HOLIBOB_BOOKING'
export const CREATE_HOLIBOB_BOOKING = 'CREATE_HOLIBOB_BOOKING'
export const SUBMIT_HOLIBOB_BOOKING_ANSWERS = 'SUBMIT_HOLIBOB_BOOKING_ANSWERS'
export const GET_HOLIBOB_BOOKING_VOUCHER = 'GET_HOLIBOB_BOOKING_VOUCHER'
export const REQUEST_HOLIBOB_CANCELLATION = 'REQUEST_HOLIBOB_CANCELLATION'
export const GET_CHATBOT_RESPONSE = 'GET_CHATBOT_RESPONSE'
export const GET_GPT_EVERYTHING_SEARCH = 'GET_GPT_EVERYTHING_SEARCH'
export const GET_GPT_DESTINATION_DETAILS = 'GET_GPT_DESTINATION_DETAILS'
export const GET_GPT_DESTINATION_EXTRAS = 'GET_GPT_DESTINATION_EXTRAS'
export const GET_GPT_DESTINATION_RECOMMENDATIONS = 'GET_GPT_DESTINATION_RECOMMENDATIONS'
export const GET_GPT_SIMILAR_DESTINATIONS = 'GET_GPT_SIMILAR_DESTINATIONS'
export const GET_GPT_RECOMMENDED_EXPERIENCES = 'GET_GPT_RECOMMENDED_EXPERIENCES'
export const GET_EXTERNAL_CARDS = 'GET_EXTERNAL_CARDS'
export const SAVE_EXTERNAL_CARD = 'SAVE_EXTERNAL_CARD'
export const REMOVE_EXTERNAL_CARD = 'REMOVE_EXTERNAL_CARD'
export const GET_CORPORATE_EXTERNAL_CARD = 'GET_CORPORATE_EXTERNAL_CARD'
export const REMOVE_CORPORATE_EXTERNAL_CARD = 'REMOVE_CORPORATE_EXTERNAL_CARD'
export const PURCHASE_COMPANY_POINTS = 'PURCHASE_COMPANY_POINTS'
export const GET_FLIGHT_OFFERS = 'GET_FLIGHT_OFFERS'
export const GET_CHEAPEST_FLIGHT = 'GET_CHEAPEST_FLIGHT'
export const GET_FLIGHT_PRICE_ANALYSIS = 'GET_FLIGHT_PRICE_ANALYSIS'
export const GET_FLIGHT_INSPIRATION = 'GET_FLIGHT_INSPIRATION'
export const SEND_USER_POINTS = 'SEND_USER_POINTS'
export const GET_CORPORATE_POINTS_HISTORY = 'GET_CORPORATE_POINTS_HISTORY'
export const SEARCH_TRAVEL_LEISURE_BY_GEO = 'SEARCH_TRAVEL_LEISURE_BY_GEO'
export const SEARCH_TRAVEL_LEISURE = 'SEARCH_TRAVEL_LEISURE'
export const SEARCH_TRAVEL_LEISURE_AREA = 'SEARCH_TRAVEL_LEISURE_AREA'
export const GET_TRAVEL_LEISURE_RESORT = 'GET_TRAVEL_LEISURE_RESORT'
export const GET_TRAVEL_LEISURE_AVAILABILITIES = 'GET_TRAVEL_LEISURE_AVAILABILITIES'
export const CREATE_TRAVEL_LEISURE_CART = 'CREATE_TRAVEL_LEISURE_CART'
export const BOOK_TRAVEL_LEISURE = 'BOOK_TRAVEL_LEISURE'
export const GET_REWARD_BADGES = 'GET_REWARD_BADGES'